import { render } from "./InvitationTC.vue?vue&type=template&id=725b75b0&scoped=true"
import script from "./InvitationTC.vue?vue&type=script&lang=js"
export * from "./InvitationTC.vue?vue&type=script&lang=js"

import "./InvitationTC.vue?vue&type=style&index=0&id=725b75b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725b75b0"]])

export default __exports__